import { useQueryClient } from '@tanstack/react-query';

import { ImportEntitiesModal } from '@/modules/onboarding/common/import-entities-modal/import-entities-modal';
import { invalidateOnboardingTeamMemberValidationReport } from '@/modules/onboarding/common/utils/onboarding-query-invalidation';
import { importEmployeesFromCsv } from '@/modules/onboarding/team-setup/api/employees';

import { getErrorMembersColumns } from './error-members-import-columns';

export function ImportOnboardingMembersModal({
  onSuccess,
}: {
  onSuccess?: (addedCount: number) => void;
}) {
  const queryClient = useQueryClient();

  return (
    <ImportEntitiesModal
      entityRelatedProps={{
        templateLinkHref: '/templates/members-template.csv',
        templateLinkLabel: 'members-template.csv',
        importEntitiesFromCsv: async (file: File) => {
          const result = await importEmployeesFromCsv(file);
          return result.importErrors ?? [];
        },
        onSuccess: async addedCount => {
          await invalidateOnboardingTeamMemberValidationReport(queryClient);
          onSuccess?.(addedCount);
        },
        res: {
          addedSuccessfully: 'authenticated.onboarding.team:importMembers.addedSuccessfully',
          title: 'authenticated.onboarding.team:importMembers.title',
          failedImport: 'authenticated.onboarding.team:importMembers.failedImport',
          successImport: 'authenticated.onboarding.team:importMembers.successImport',
          step1Description: 'authenticated.onboarding.team:importMembers.step1Description',
          step2Description: 'authenticated.onboarding.team:importMembers.step2Description',
          backToImport: 'authenticated.onboarding.team:importMembers.backToImport',
        },
      }}
      getErrorEntitiesColumns={getErrorMembersColumns}
      importStringResource={'authenticated.onboarding.team:import'}
    />
  );
}
